import { error } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';

export const load: LayoutLoad = ({ params, parent }) => {
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);
  return {
    meta: {
      title: 'Classes',
      breadcrumbs: {
        activeTitle: 'New Skill Log Entry',
        items: [
          {
            title: 'Classes',
            href: '/classes',
          },
          {
            title: parent()
              .then(x => x.classPromise)
              .then(x => x.class.name),
            href: `/classes/${id}`,
          },
        ],
      },
    },
  };
};
